export const SCREENING_METHOD_STATUS = {
  ACCEPT: 'accept',
  ACCEPT_WITH_CONDITIONS: 'acceptWithConditions',
  FAIL: 'fail',
  REFER: 'refer',
  PENDING: 'pending',
  CANCELED: 'canceled',
  ERROR: 'error',
  NOT_READY: 'notReady',
  NOT_STARTED: 'notStarted',
};
